import {Component} from "@angular/core";
import {CommonModule} from "@angular/common";
import { DatePickerAdapter, MotifFormsModule, NativeDateTimeAdapter } from '@ey-xd/ng-motif';
import {
  ButtonSizes,
  MotifButtonModule,
  MotifDropdownModule,
  MotifIconModule,
  MotifModalModule,
  MotifTooltipModule
} from "@ey-xd/ng-motif";
import {IconoirMoreVert, IconoirNavArrowLeft, IconoirNavArrowRight, IconoirXmark} from "@ey-xd/motif-icon";
import { NgComponentOutlet } from "@angular/common";
import {
  MOTIF_DATE_TIME_FORMATS, MotifDatePickerFormats,
  MotifDatePickerModule,
  MotifNativeDateTimeModule
} from "@ey-xd/ng-motif";
import {FormControl, FormsModule, ReactiveFormsModule} from "@angular/forms";
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';
import { FeedbackService } from "app/core/service/feedback/feedback.service";
import { ApiResponseReader } from "app/core/service/api/api-response.service";
import { HttpErrorResponse } from "@angular/common/http";
import saveAs from "file-saver";
@Component({
  selector: 'survey-export-modal',
  templateUrl: './survey-export-modal.component.html',
  styleUrls: ['./survey-export-modal.component.scss'],
  imports: [CommonModule,
    MotifModalModule,
    MotifButtonModule,
    MotifDropdownModule,
    MotifIconModule,
    MotifTooltipModule,
  MotifFormsModule,
  CommonModule, MotifFormsModule, ReactiveFormsModule, FormsModule,
  MotifDatePickerModule,
  MotifNativeDateTimeModule,],
  providers: [
    {
      provide: DatePickerAdapter,
      useClass: NativeDateTimeAdapter
    },
    {provide: MOTIF_DATE_TIME_FORMATS, useValue: {...MOTIF_DATE_TIME_FORMATS,
            datePickerInput: { year: 'numeric', month: 'numeric'}}}
],
  standalone: true
})
export class ModalExportSurverys {
  ButtonSizes = ButtonSizes;
  IconoirXmark = IconoirXmark;
  IconoirMoreVert = IconoirMoreVert;
  IconoirNavArrowLeft = IconoirNavArrowLeft;
  IconoirNavArrowRight = IconoirNavArrowRight;
  selectedAgent?: string;
  dateSingleFormControl = new FormControl();
  selectAgentFormControl = new FormControl();
  initialDate?: string;
  finalDate?: string;
  meRole: string = "0"

  constructor(private feedbackService: FeedbackService) {
   
  }

  onSurveyExport() {
    if(this.dateSingleFormControl.value) {
      this.initialDate = this.dateSingleFormControl.value[0].toLocaleDateString('en-CA');
      this.finalDate = this.dateSingleFormControl.value[1].toLocaleDateString('en-CA');
    } else {
      this.initialDate = "";
      this.finalDate = ""
    }
    
    if(this.selectAgentFormControl.value) {
      this.selectedAgent = this.selectAgentFormControl.value;
    } else {
      this.selectedAgent = "tbe"
    }
    this.feedbackService
      .exportSurvey(this.selectedAgent!, this.initialDate!, this.finalDate!)
      .subscribe({
        next: (data: Blob) => {
            console.log("entra1");
            const nameFromApi: string = 'CiT Feedback Report.xlsx';
            saveAs(data, nameFromApi);
        },
        error: (error: HttpErrorResponse) => {
            console.log(error);
        },
      });
  }
}





